import Component from 'navigation/component/Component';
import browser from 'helpers/browser';
import mqStore from 'store/mqStore';
class Player extends Component {
    raf = 0;
    leftOffset = 0;
    initialized() {
        this.resize();
        super.initialized();
    }
    bindEvents(add = true) {
        const m = add ? 'addEventListener' : 'removeEventListener';
        this.refs.fullscreenVideo[m]('click', this.onFullscreenClicked);
        this.refs.muteVideo[m]('click', this.onMuteClicked);
        this.refs.playVideo[m]('click', this.onPlayClicked);
        this.refs.progressVideoWrapper[m]('click', this.onProgressClicked);
        this.refs.video[m]('play', this.onVideoPlay);
        this.refs.video[m]('pause', this.onVideoPause);
        this.refs.video[m]('ended', this.onVideoEnded);
        if (add)
            this.tick();
        else
            window.cancelAnimationFrame(this.raf);
    }
    onFullscreenClicked = (event) => {
        if (!document.fullscreenElement) {
            // Mobile fullscreen not working correctly now
            browser.requestFullscreen(mqStore.tabletPortrait.value ? this.refs.video : this.refs.videoWrapper);
            // browser.requestFullscreen(this.refs.video)
        }
        else {
            browser.exitFullscreen();
        }
    };
    onMuteClicked = (event) => {
        if (this.refs.video.muted) {
            this.refs.video.muted = false;
            this.refs.muteVideo.innerHTML = 'SOUND OFF';
        }
        else {
            this.refs.video.muted = true;
            this.refs.muteVideo.innerHTML = 'SOUND ON';
        }
    };
    onPlayClicked = (event) => {
        if (this.refs.video.paused)
            this.refs.video.play();
        else
            this.refs.video.pause();
    };
    onProgressClicked = (event) => {
        const { pageX } = event;
        const posX = pageX - this.leftOffset, max = this.refs.progressVideo.offsetWidth, nextTime = (posX / max);
        this.refs.video.currentTime = nextTime * this.refs.video.duration;
    };
    onVideoPlay = () => {
        this.el.classList.add('playing');
    };
    onVideoPause = () => {
        this.el.classList.remove('playing');
    };
    onVideoEnded = (event) => {
        this.el.classList.remove('playing');
    };
    updateProgressBar = () => {
        if (!this.refs.video)
            return;
        const ratio = (this.refs.video.currentTime / this.refs.video.duration);
        this.refs.progressVideo.style.transform = `translateX(${(ratio - 1) * 100}%)`;
    };
    resize() {
        super.resize();
        if (!this.refs)
            return;
        this.leftOffset = this.refs.progressVideoWrapper.getBoundingClientRect().left;
    }
    tick = () => {
        this.raf = window.requestAnimationFrame(this.tick);
        this.updateProgressBar();
    };
}
export default Player;
